<template>
  <TitledInputField
  :inputLabel="inputLabel"
  :iconName="iconName"
  :tooltipText="tooltipText"
>
    <template #inputComponent>
      <ThemedTextField
        outlined
        :value="value"
        @change="onChange"
        :rules="rules"
      ></ThemedTextField>
    </template>
  </TitledInputField>
</template>

  <script>
import TitledInputField from "./TitledInputField.vue";
import ThemedTextField from "../../../core/ThemedTextField.vue";
export default {
  name: "TitledNumberInputField",
  components: {
    TitledInputField,
    ThemedTextField,
  },
  props: {
    inputLabel: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
    iconName: {
      type: String,
      default: null, // Default icon
    },
    tooltipText: {            // ✅ NEW
    type: String,
    default: null,
    },
    onChange: {
      type: Function,
      required: true,
    },
    rules: {
      type: Array[Function],
      default() {
        return [];
      },
    },
  },
};
</script>
